import React, { useEffect } from "react";
import "./Asesores.css";
import { FaWhatsapp } from "react-icons/fa";

const asesores = [
  {
    nombre: "Luis Chavez",
    puesto: "Asesor de ventas",
    telefono: "528717867659",
    imagen: "/asesores/luis.jpg",
  },
  {
    nombre: "America Salazar",
    puesto: "Asesora de ventas",
    telefono: "528717867393",
    imagen: "/asesores/america.jpg",
  },
  {
    nombre: "Ana Cortes",
    puesto: "Asesora de ventas",
    telefono: "528713567094",
    imagen: "/asesores/anacortez.jpg",
  },
  {
    nombre: "Ruben Badillo",
    puesto: "Asesor de ventas",
    telefono: "528713567289",
    imagen: "/asesores/ruben.jpg",
  },
  {
    nombre: "Yasmin Jaramillo",
    puesto: "Asesora de ventas",
    telefono: "528717356985",
    imagen: "/asesores/yasmin.jpg",
  },
  {
    nombre: "Lizbeth Renteria",
    puesto: "Asesora de ventas",
    telefono: "52815709631",
    imagen: "/asesores/lizbeth.jpg",
  },
];

const Asesores = () => {
  useEffect(() => {
    document.title = 'AITA - Asesores de venta';
  }, []);

  return (
    <section className="aita-asesores">
      <div className="aita-asesores-shell">
        <header className="aita-asesores-header">
          <span className="aita-asesores-chip">Atención personalizada</span>
          <h2 className="aita-asesores-title">Conoce a tu asesor AITA</h2>
          <p className="aita-asesores-description">
            Nuestros asesores te acompañan en todo el proceso: elección de
            producto, explicación del crédito y seguimiento de tu compra.
            Contáctalos directamente por WhatsApp.
          </p>
        </header>

        <div className="aita-asesores-list">
          {asesores.map((asesor, index) => (
            <article className="aita-asesores-item" key={index}>
              <div className="aita-asesores-photo-wrapper">
                <img
                  src={asesor.imagen}
                  alt={asesor.nombre}
                  className="aita-asesores-photo"
                />
              </div>

              <div className="aita-asesores-info">
                <h3 className="aita-asesores-name">{asesor.nombre}</h3>
                <p className="aita-asesores-role">{asesor.puesto}</p>
                <p className="aita-asesores-small">
                  Resuelve dudas, solicita una cotización o conoce los planes
                  de pago disponibles para tu crédito.
                </p>

                <a
                  href={`https://wa.me/${asesor.telefono}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="aita-asesores-whatsapp"
                >
                  <FaWhatsapp className="aita-asesores-whatsapp-icon" />
                  <span>Hablar por WhatsApp</span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Asesores;
